export const IconStyle = {
	OUTLINED : 'outlined',
	SOLID : 'solid'
}

export const IconSize = {
	SMALL : 'small',
	MEDIUM : 'medium',
	LARGE : 'large',
	XLARGE : 'xlarge'
}
